export const facebookMixin = {
    mounted() {
        this.$nextTick(() => {
            this.sendFacebookCookies();
        });
    },
    methods: {
        async sendFacebookCookies() {
            if (this.$globalState.trafficSource === 'facebook') {
                let cookies = decodeURIComponent(document.cookie).split(';');
                let cookie_names = ['_fbp', '_fbc'];

                var fb_cookies = [];

                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i];

                    while (cookie.charAt(0) == ' ') {
                        cookie = cookie.substring(1);
                    }

                    for (let j = 0; j < cookie_names.length; j++) {
                        if (cookie.indexOf(cookie_names[j] + '=') == 0) {
                            fb_cookies.push(
                                cookie.replace(cookie_names[j] + '=', '')
                            );
                        }
                    }
                }

                window.axios.get(
                    `${document.location.origin}/callback/clickin_data?data=${fb_cookies}&user_id=${this.$globalConstants.userId}&clickin_id=${this.$globalConstants.clickinId}&source=${this.$globalState.trafficSource}`
                );
            }
        },
    },
};
